// src/theme.ts
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#18090aed', // <-- Replace with your brand color (hex or CSS color)
    },
    secondary: {
      main: '#ffe6a7', // optional
    },
  },
});

export default theme;